<template>
  <div>
    <div class="v-form-builder-question__label">{{ i18n.answerOptions }}</div>
    <div
      v-for="(option, optionIndex) in question.options"
      :key="option.id"
      class="v-form-builder-question__option"
      :class="{ 'is-dragging': draggable.draggingIndex === optionIndex }"
      draggable="true"
      @dragend="draggable.dragend"
      @dragover="draggable.dragover(optionIndex, $event)"
      @dragstart="draggable.dragstart(optionIndex, $event)"
    >
      <VInput
        v-model="option.label"
        draggable="true"
        :error="!option.label ? blueprint.errors[question.id]?.options : undefined"
        :focus-on-mount="isMounted"
        size="medium"
        @dragstart.prevent.stop
      />
      <slot name="dropdown-option" :option :question />
      <VIcon class="v-form-builder-question__option-grabber" draggable="true" icon="Grab" :size="19" type="placeholder" />
      <VButton
        v-if="question.options.length > 1"
        class="v-form-builder-question__delete"
        icon="Delete"
        icon-type="info"
        rounded
        tabindex="-1"
        type="icon"
        @click="Array.isArray(question.options) ? question.options.splice(optionIndex, 1) : undefined"
      />
    </div>

    <VButton :label="i18n.addAnswerOption" size="small" type="secondary" @click="Array.isArray(question.options) ? question.options.push(blueprint.createOption('')) : undefined" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import { useDraggable } from '../../composables/useDraggable.ts'
import { i18nFormBuilder as i18n } from '../../utils/i18n.ts'
import VIcon from '../Icon/VIcon.vue'
import VButton from '../VButton.vue'
import VInput from '../VInput.vue'
import { type Blueprint, type DropdownQuestion, type QuestionOption } from './useBlueprint.ts'

interface Props {
  blueprint: Blueprint
  question: DropdownQuestion
}

const { question, blueprint } = defineProps<Props>()

defineSlots<{
  'dropdown-option'(props: { question: DropdownQuestion; option: QuestionOption }): any
}>()

const draggable = useDraggable(computed((): unknown[] => (Array.isArray(question.options) ? question.options : [])))

const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})
</script>
